document.addEventListener('DOMContentLoaded', () => {
    'use strict';

    //Place all your custom Javascript functions and plugin calls below this line
    function init_template() {
        //Caching Global Variables
        var i, e, el; //https://www.w3schools.com/js/js_performance.asp

        //Attaching Menu Hider
        var menuHider = document.getElementsByClassName('menu-hider');
        if (!menuHider.length) {
            var hider = document.createElement('div');
            hider.setAttribute('class', 'menu-hider');
            document.body.insertAdjacentElement('beforebegin', hider);
        }
        setTimeout(function () {
            if (hider.classList.contains('menu-active')) {
                hider.classList.remove('menu-active');
            }
        }, 50);

        //Activating Menus
        document.querySelectorAll('.menu').forEach(el => {
            el.style.display = 'flex';
        });

        //Setting Sidebar Widths
        var menus = document.querySelectorAll('.menu');
        if (menus.length) {
            var menuSidebar = document.querySelectorAll(
                '.menu-box-left, .menu-box-right'
            );
            menuSidebar.forEach(function (e) {
                if (e.getAttribute('data-menu-width') === 'cover') {
                    e.style.width = '100%';
                } else {
                    e.style.width = e.getAttribute('data-menu-width') + 'px';
                }
            });
            var menuSheets = document.querySelectorAll(
                '.menu-box-bottom, .menu-box-top, .menu-box-modal'
            );
            menuSheets.forEach(function (e) {
                if (e.getAttribute('data-menu-width') === 'cover') {
                    e.style.width = '100%';
                    e.style.height = '100%';
                } else {
                    e.style.width = e.getAttribute('data-menu-width') + 'px';
                    e.style.height = e.getAttribute('data-menu-height') + 'px';
                }
            });

            //Opening Menus
            var menuOpen = document.querySelectorAll('[data-menu]');
            var wrappers = document.querySelectorAll(
                '.header, #footer-bar, .page-content'
            );

            menuOpen.forEach(el =>
                el.addEventListener('click', e => {
                    //Close Existing Opened Menus
                    const activeMenu =
                        document.querySelectorAll('.menu-active');
                    for (let i = 0; i < activeMenu.length; i++) {
                        activeMenu[i].classList.remove('menu-active');
                    }
                    //Open Clicked Menu
                    var menuData = el.getAttribute('data-menu');
                    document
                        .getElementById(menuData)
                        .classList.add('menu-active');
                    document
                        .getElementsByClassName('menu-hider')[0]
                        .classList.add('menu-active');
                    //Check and Apply Effects
                    var menu = document.getElementById(menuData);
                    var menuEffect = menu.getAttribute('data-menu-effect');
                    var menuLeft = menu.classList.contains('menu-box-left');
                    var menuRight = menu.classList.contains('menu-box-right');
                    var menuTop = menu.classList.contains('menu-box-top');
                    var menuBottom = menu.classList.contains('menu-box-bottom');
                    var menuWidth = menu.offsetWidth;
                    var menuHeight = menu.offsetHeight;

                    if (menuEffect === 'menu-push') {
                        var menuWidth = document
                            .getElementById(menuData)
                            .getAttribute('data-menu-width');
                        if (menuLeft) {
                            for (let i = 0; i < wrappers.length; i++) {
                                wrappers[i].style.transform =
                                    'translateX(' + menuWidth + 'px)';
                            }
                        }
                        if (menuRight) {
                            for (let i = 0; i < wrappers.length; i++) {
                                wrappers[i].style.transform =
                                    'translateX(-' + menuWidth + 'px)';
                            }
                        }
                        if (menuBottom) {
                            for (let i = 0; i < wrappers.length; i++) {
                                wrappers[i].style.transform =
                                    'translateY(-' + menuHeight + 'px)';
                            }
                        }
                        if (menuTop) {
                            for (let i = 0; i < wrappers.length; i++) {
                                wrappers[i].style.transform =
                                    'translateY(' + menuHeight + 'px)';
                            }
                        }
                    }
                    if (menuEffect === 'menu-parallax') {
                        var menuWidth = document
                            .getElementById(menuData)
                            .getAttribute('data-menu-width');
                        if (menuLeft) {
                            for (let i = 0; i < wrappers.length; i++) {
                                wrappers[i].style.transform =
                                    'translateX(' + menuWidth / 10 + 'px)';
                            }
                        }
                        if (menuRight) {
                            for (let i = 0; i < wrappers.length; i++) {
                                wrappers[i].style.transform =
                                    'translateX(-' + menuWidth / 10 + 'px)';
                            }
                        }
                        if (menuBottom) {
                            for (let i = 0; i < wrappers.length; i++) {
                                wrappers[i].style.transform =
                                    'translateY(-' + menuHeight / 5 + 'px)';
                            }
                        }
                        if (menuTop) {
                            for (let i = 0; i < wrappers.length; i++) {
                                wrappers[i].style.transform =
                                    'translateY(' + menuHeight / 5 + 'px)';
                            }
                        }
                    }
                })
            );

            //Closing Menus
            const menuClose = document.querySelectorAll(
                '.close-menu, .menu-hider, #menuClose'
            );
            menuClose.forEach(el =>
                el.addEventListener('click', e => {
                    const activeMenu =
                        document.querySelectorAll('.menu-active');
                    for (let i = 0; i < activeMenu.length; i++) {
                        activeMenu[i].classList.remove('menu-active');
                    }
                    var iframes = document.querySelectorAll('iframe');
                    iframes.forEach(el => {
                        var hrefer = el.getAttribute('src');
                        el.setAttribute('newSrc', hrefer);
                        el.setAttribute('src', '');
                        var newSrc = el.getAttribute('newSrc');
                        el.setAttribute('src', newSrc);
                    });
                })
            );
        }

        //Accordion Rotate
        const accordionBtn = document.querySelectorAll('.accordion-btn');
        if (accordionBtn.length) {
            accordionBtn.forEach(el =>
                el.addEventListener('click', event => {
                    el.querySelector('i:last-child').classList.toggle(
                        'fa-rotate-180'
                    );
                })
            );
        }

        //Collapse Flip Icon
        var collapseBtn = document.querySelectorAll(
            '[data-bs-toggle="collapse"]:not(.no-effect)'
        );
        if (collapseBtn.length) {
            collapseBtn.forEach(el =>
                el.addEventListener('click', e => {
                    if (el.querySelectorAll('i').length) {
                        el.querySelector('i:first-child').classList.toggle(
                            'mcp-nav-button-hide'
                        );
                        el.querySelector('i:last-child').classList.toggle(
                            'mcp-nav-button-hide'
                        );
                    }
                })
            );
        }

        //Extending Menu Functions
        function menu(menuName, menuFunction, menuTimeout) {
            setTimeout(function () {
                if (menuFunction === 'show') {
                    return (
                        document
                            .getElementById(menuName)
                            .classList.add('menu-active'),
                        document
                            .querySelectorAll('.menu-hider')[0]
                            .classList.add('menu-active')
                    );
                } else {
                    return (
                        document
                            .getElementById(menuName)
                            .classList.remove('menu-active'),
                        document
                            .querySelectorAll('.menu-hider')[0]
                            .classList.remove('menu-active')
                    );
                }
            }, menuTimeout);
        }

        var autoActivate = document.querySelectorAll('[data-auto-activate]');
        if (autoActivate.length) {
            setTimeout(function () {
                autoActivate[0].classList.add('menu-active');
                menuHider[0].classList.add('menu-active');
            }, 60);
        }
    }

    init_template();
});
